import ButtonType1 from "../../components/ButtonType1/ButtonType1";
import CollectionCard from "../../components/CollectionCard/CollectionCard";
import { collections } from "../../data/collections";

const MyProfile = () => {
    return (
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 pb-20 lg:pb-36">
            
            <div className="flex flex-col tracking-wider py-10">

                <div className="flex w-full justify-center mb-10">
                    <p className="text-base md:text-lg mb-2 mr-5">
                        NFT Owned: <span className = 'text-gray-400'> 23 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 mr-5">
                        Highest Purchase: <span className = 'text-gray-400'> $5000 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 mr-5">
                        Joined: <span className = 'text-gray-400'> 23 Sep, 2021 </span>
                    </p>
                </div>

                <div className="flex flex-col xl:flex-row xl:justify-between">

                    <div className="xl:w-[30%] h-fit px-4 sm:px-12 flex flex-col justify-center p-3 mb-2 md:m-2 shadow-shadow3 rounded-[8px] bg_gradient">
                        <div className="my-10 flex flex-col items-center">
                            <img className="w-[70px] h-[70px] rounded-[50%] mb-5"  alt = 'profilepic'
                                src = 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80'/>
                            <p className="text-base md:text-lg mb-3">
                                @fillipebargehela
                            </p>
                            <p className="mb-5 text-sm tracking-widest border-[1px] border-gray-300 text-gray-300 rounded-[8px] px-3 py-1">
                                VERIFIED
                            </p>
                            <p className="mb-5 text-sm text-gray-300 text-center">
                                I am a basic guy with a lots of affection around arts and nfts and money ofc heehe! Good to have my wallet backedup here feeling so secured rn!
                            </p>
                        </div>
                        <div className="flex flex-col mb-10">
                            <div className="mb-5">
                                <p className="mb-2 text-sm text-gray-300">
                                    Email
                                </p>
                                <p className="text-sm">
                                    abdullamidi456@gmail.com
                                </p>
                            </div>
                            <div className="mb-5">
                                <p className="mb-2 text-sm text-gray-300">
                                    Name
                                </p>
                                <p className="text-sm">
                                    Abdull Amidi
                                </p>
                            </div>
                            <div className="mb-5">
                                <p className="mb-2 text-sm text-gray-300">
                                    Phone
                                </p>
                                <p className="text-sm">
                                    +92 3201210805
                                </p>
                            </div>
                            <div className="mb-5">
                                <p className="mb-2 text-sm text-gray-300">
                                    Address
                                </p>
                                <p className="text-sm">
                                    Kawlar, Dhaka, Bandesh
                                </p>
                            </div>
                        </div>
                        <div className="w-full flex justify-center mb-10">
                            <a href = '/' target='_blank' rel = 'noreferrer' className="text-sm text-gray-300 hover:text-white mr-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className = 'w-[30px] h-[30px]' viewBox="0 0 496 512">
                                    <path d="M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"/>
                                </svg>
                            </a>
                            <a href = '/' target='_blank' rel = 'noreferrer' className="text-sm text-gray-300 hover:text-white mr-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className = 'w-[30px] h-[30px]' viewBox="0 0 448 512">
                                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                                </svg>
                            </a>
                            <a href = '/' target='_blank' rel = 'noreferrer' className="text-sm text-gray-300 hover:text-white mr-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' className = 'w-[30px] h-[30px]' viewBox="0 0 512 512">
                                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div className="xl:w-[70%] flex flex-col md:m-2">

                        <div className="flex flex-col md:flex-row md:justify-between mb-5">
                            <div className="mb-2 md:mb-0 md:mr-3 shadow-shadow3 bg_gradient py-6 px-3 md:p-5 rounded-[8px] flex-grow">
                                <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Overall</h2>
                                <div className="flex flex-col md:flex-row items-center md:justify-between">
                                    <div className="w-full md:max-w-[48%] shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                                        <p className="text-base mb-8">
                                            Deposit
                                        </p>
                                        <p className="text-base mb-2 text-[#DE00FF]">
                                            ETH
                                        </p>
                                        <p className="text-base xl:text-lg font-[500] mb-4">
                                            9213123.123
                                        </p>
                                        <div className="flex justify-between mb-3">
                                            <p className="text-sm xl:text-base">
                                                Transactions
                                            </p>
                                            <button className="text-sm xl:text-base border-b-[1px] border-gray-400 text-gray-400">
                                                See all
                                            </button>
                                        </div>
                                        <div className="flex justify-between mb-8">
                                            <p className="text-sm xl:text-base">
                                                <span className="text-[#DE00FF]">ETH</span> 314.2123
                                            </p>
                                            <button className="text-sm xl:text-base text-gray-400 border-b-[1px] border-gray-400">
                                                taxwas..
                                            </button>
                                        </div>
                                        <div className="w-full flex justify-center mb-4">
                                            <ButtonType1 title='Deposit' className="w-[150px]"/>
                                        </div>
                                    </div>

                                    <div className="w-full md:max-w-[48%] shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                                        <p className="text-base mb-8">
                                            Earning
                                        </p>
                                        <p className="text-base mb-2 text-[#DE00FF]">
                                            ETH
                                        </p>
                                        <p className="text-base xl:text-lg font-[500] mb-4">
                                            9213123.123
                                        </p>
                                        <div className="flex justify-between mb-3">
                                            <p className="text-sm xl:text-base">
                                                Latest Sell
                                            </p>
                                            <button className="text-sm xl:text-base border-b-[1px] border-gray-400 text-gray-400">
                                                See all
                                            </button>
                                        </div>
                                        <div className="flex justify-between mb-8">
                                            <p className="text-sm xl:text-base">
                                                <span className="text-[#DE00FF]">ETH</span> 314.2123
                                            </p>
                                            <button className="text-sm xl:text-base text-gray-400 border-b-[1px] border-gray-400">
                                                taxwas..
                                            </button>
                                        </div>
                                        <div className="w-full flex justify-center mb-4">
                                            <ButtonType1 title='Withdraw' className="w-[150px]"/>
                                        </div>
                                    </div>
     
                                </div>

                            </div>

                            <div className="shadow-shadow3 bg_gradient p-5 rounded-[8px]">
                                <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Currency</h2>
                                <div className="flex justify-between mb-2">
                                    <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                                    <p className="text-sm xl:text-base">$5012.12</p>
                                </div>
                                <div className="flex justify-between mb-2">
                                    <p className="text-sm xl:text-base text-[#FF8A00]">BTC</p>
                                    <p className="text-sm xl:text-base">$5012.12</p>
                                </div>
                                <div className="flex justify-between mb-2">
                                    <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                                    <p className="text-sm xl:text-base">$5012.12</p>
                                </div>
                                <div className="flex justify-between mb-2">
                                    <p className="text-sm xl:text-base text-[#FF8A00]">BTC</p>
                                    <p className="text-sm xl:text-base">$5012.12</p>
                                </div>
                                <div className="flex justify-between mb-2">
                                    <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                                    <p className="text-sm xl:text-base">$5012.12</p>
                                </div>
                            </div>

                        </div>

                        <div className="flex flex-col shadow-shadow3 bg_gradient px-5 py-10">
                            <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Collections</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                                {collections.map((item, index) => {
                                    if(index < 6){
                                        return (
                                            <CollectionCard item={item} key = {index} className = "p-3 shadow-shadow3" />
                                        )
                                    }
                                    else{
                                        return null;
                                    }
                                })}
                            </div>
                        </div>


                    </div>

                </div>

            </div>

        </div>
    )
}

export default MyProfile;